import { jsx as t } from "react/jsx-runtime";
import { InputField as e } from "./InputField.js";
const a = /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ0-9]*$/, o = /[^a-zA-Zа-яА-ЯіІїЇєЄґҐ0-9]/g, r = (r2) => t(e, { ...r2, onInput: (t2) => {
  const e2 = t2.target;
  a.test(e2.value) || (e2.value = e2.value.replace(o, ""));
}, loading: r2.loading });
export {
  r as InputAlphanumericField,
  a as REGEX_MATCH_ALPHANUMERIC_LATIN_CYRILLIC,
  o as REGEX_REPLACE_ALPHANUMERIC_LATIN_CYRILLIC
};
//# sourceMappingURL=InputAlphanumericField.js.map
